module.exports = __webpack_public_path__ + "img/warsztaty-filipiny-1.a083f39b.jpg";